export const loadInitializeOneDS = (): Promise<typeof import('./initializeOneDS')> =>
  import(/* webpackChunkName: "4-feat-initialize-one-ds" */ './initializeOneDS');

export const loadReportOneDSEvent = (): Promise<typeof import('./reportOneDSEvent')> =>
  import(/* webpackChunkName: "4-feat-report-one-ds-event" */ './reportOneDSEvent');
